import PropTypes from 'prop-types'
import React from 'react'

import IconInCircle from 'components/IconInCircle'

import { Wrapper } from './styles'

const ICONS = {
  bacteria_scientist: {
    height: '120%',
    width: '120%',
    left: '-16%',
    top: 'auto',
    bottom: '20px',
  },
  mobile: {
    height: '180%',
    width: '100%',
    left: 'auto',
    top: 'auto',
    bottom: '-30%',
  },
  charts_biome_white: {
    left: '21%',
    height: '100%',
    width: '100%',
    bottom: '10px',
    top: 'auto',
  },
}

/**
 * BAboutFeature
 *
 * @param {object} props - properties of component
 * @returns {node} BAboutFeature
 */
const BNutritionFeature = props => {
  const { item } = props
  const iconParams = ICONS[item.icon]

  if (!iconParams) {
    return null
  }

  return (
    <Wrapper>
      <IconInCircle
        icon={`color_${item.icon}`}
        iconW={iconParams.width}
        iconH={iconParams.height}
        iconLeft={iconParams.left}
        iconTop={iconParams.top}
        iconBottom={iconParams.bottom}
        description={item.title}
      />
    </Wrapper>
  )
}

BNutritionFeature.propTypes = {
  item: PropTypes.object.isRequired,
}

BNutritionFeature.defaultProps = {}

export default BNutritionFeature
